import get from 'lodash/get'
import isArray from 'lodash/isArray'
import { urls } from 'optinmonster-js-library/src/vue/utils'
import store from '../store'

const updatedUrls = {}
Object.keys(urls).forEach(k => {
	updatedUrls[k] = 'campaign' === k
		? (id, path, returnUrl, isLegacy) => {
			if (!returnUrl) {
				returnUrl = window.location.href
			}

			let url = urls[k](id, path, returnUrl, isLegacy)
			const accountId = get(store, 'state.user.accountUserId')

			if (accountId) {
				// If on WP and we have an account id, let's make sure they get switched to the right account when they go to the app.
				let appUrl = new URL(urls.app())
				appUrl.searchParams.set('redirect_to', encodeURIComponent(url))
				appUrl.searchParams.set('accountId', accountId)
				url = appUrl.toString()
			}

			return url
		}
		: urls[k]
})

/**
 * Gets a url with utm query args.
 *
 * @since  2.0.0
 *
 * @param  {string} destination The URL to append the query params to.
 * @param  {Array} queryArgs Query arguments for upgrade page url.
 * @param  {boolean} toString Whether to return URL as string (or URL object).
 *
 * @returns {string} The url.
 */
updatedUrls.utmLink = (destination, {
	// eslint-disable-next-line camelcase
	utm_source   = 'WordPress',
	// eslint-disable-next-line camelcase
	utm_medium   = '', // E.g. Wizard
	// eslint-disable-next-line camelcase
	utm_campaign = 'Plugin',
	// eslint-disable-next-line camelcase
	utm_content  = '',
	...additionalArgs
} = {}, toString = true) => {
	destination = new URL(destination)

	// eslint-disable-next-line camelcase
	if (utm_source || 0 === utm_source) {
		destination.searchParams.set('utm_source', utm_source)
	}

	// eslint-disable-next-line camelcase
	if (utm_medium || 0 === utm_medium) {
		destination.searchParams.set('utm_medium', utm_medium)
	}

	// eslint-disable-next-line camelcase
	if (utm_campaign || 0 === utm_campaign) {
		destination.searchParams.set('utm_campaign', utm_campaign)
	}

	// eslint-disable-next-line camelcase
	if (utm_content || 0 === utm_content) {
		destination.searchParams.set('utm_content', utm_content)
	}

	Object.keys(additionalArgs).forEach(key => {
		const val = additionalArgs[key]
		if (val || 0 === val) {
			destination.searchParams.set(key, val)
		}
	})

	return toString ? destination.toString() : destination
}

/**
 * Gets the wp-upgrade url, ideally with a feature flag, and/or query args for
 * UTM params.
 *
 * @since  2.0.0
 *
 * @param  {Array} args Query arguments for upgrade page url.
 * @param  {string|Array} feature The feature(s) to highlight.
 *
 * @returns {string} The upgrade url.
 */
updatedUrls.upgrade = (args = {}, feature = '') => {
	const url = updatedUrls.utmLink(updatedUrls.app('account/wp-upgrade/'), args, false)

	if (feature && !url.searchParams.get('utm_content')) {
		let features = isArray(feature) ? feature : [ feature ]
		features = features && features.length ? features : [ 'none' ]
		url.searchParams.set('utm_content', features.join('|'))
		url.searchParams.set('feature', features[features.length - 1])
	}

	return url.toString()
}

/**
 * Gets the doc url with query args for UTM params.
 *
 * @since  2.0.0
 *
 * @param  {string} path Docs URL path, minus front/trailing slashes.
 * @param  {string} utmMedium The utm_medium query param.
 *
 * @returns {string} The upgrade url.
 */
updatedUrls.docs = (path = '', utmMedium = 'Docs') => {
	return updatedUrls.utmLink(updatedUrls.marketing(`docs/${path ? path + '/' : ''}`), {
		utm_medium : utmMedium,
	})
}

/**
 * Gets a link to builder with return URL auto-set to output settings.
 *
 * @since  2.0.0
 *
 * @param   {string}  id        Campaign slug
 * @param   {string}  path      Whether to show edit/preview/analytics path. Defaults to 'edit/'.
 * @param   {boolean} isLegacy Whether this is a legacy campaignn.
 * @param   {string}  returnUrl Optional return URL to add as query arg. Sets it automatically.
 *
 * @returns {string}  The builder URL.
 */
updatedUrls.builderLink = (id, path = 'edit/', isLegacy = false, returnUrl = null) => {
	if (null === returnUrl) {
		const { location } = window
		const url = new URL(location.protocol + '//' + location.host + location.pathname)
		url.searchParams.set('page', 'optin-monster-campaigns')
		url.searchParams.set('campaignId', id)
		url.searchParams.set('alert', 'review')
		returnUrl = url.toString()
	}

	return updatedUrls.campaign(id, path, encodeURIComponent(returnUrl), isLegacy)
}

export default updatedUrls
